import {LeadStatusSettingsApiDto, UpdateLeadStatusSettingsApiDto} from "../../api/model/rest";

/**
 * Lead status settings object.
 * @param settingsName
 * @param statusId
 */
export default class LeadStatusSettings {
	constructor(public readonly settingsName: string,
		public readonly statusId: string) {}

	static fromJson(json: LeadStatusSettingsApiDto): LeadStatusSettings {
		return new LeadStatusSettings(json.settingsName, json.value);
	}

	toJson(): UpdateLeadStatusSettingsApiDto {
		const json: UpdateLeadStatusSettingsApiDto = {
			settingsName: this.settingsName,
			statusId: this.statusId
		};
		return json;
	}

	copy({statusId = this.statusId}) {
		return new LeadStatusSettings(this.settingsName, statusId);
	}
}

export enum LeadStatusSettingsName {
	LeadStatusEngineerOnRoute = "LEAD_STATUS_ENGINEER_ON_ROUTE",
	LeadStatusSurveyInProgress = "LEAD_STATUS_SURVEY_IN_PROGRESS",
	LeadStatusSurveyDone = "LEAD_STATUS_SURVEY_DONE",
	LeadStatusEnquiryLost = "LEAD_STATUS_ENQUIRY_LOST"
}
